module.exports = __webpack_public_path__ + "static/img/2.f9a5dd3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.gif
// module id = SLvF
// module chunks = 13